import { useEffect } from 'react';

const useKeyListener = (key: string, callback: () => void, keyListenerAttachFlag: boolean) => {
    const handleKeyPress = (event: KeyboardEvent) => {
        if (
            event.key === key &&
            keyListenerAttachFlag &&
            callback &&
            typeof callback === 'function'
        ) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [key, keyListenerAttachFlag]);
};

export default useKeyListener;
